module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm.totais.aglutinado === 'Sim') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12 financial-physical-schedule"
  }, [_c('table', {
    ref: "tabelaCronogramaAglutinado",
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.itensProjeto), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.Item_Descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantidadeSolicitada),
        expression: "item.quantidadeSolicitada"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "name": "quantidade a solicitar",
        "type": "text"
      },
      domProps: {
        "value": (item.quantidadeSolicitada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
      staticClass: "text-center"
    }, [_c('money', {
      staticClass: "form-control text-right",
      attrs: {
        "name": "valor a solicitar",
        "type": "text"
      },
      model: {
        value: (item.valorSolicitado),
        callback: function($$v) {
          _vm.$set(item, "valorSolicitado", $$v)
        },
        expression: "item.valorSolicitado"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.Qtde_orcado - item.quantidadeSolicitada - item.Qtde_liberado || 0))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado - item.valorSolicitado - item.Valor_liberado)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(item.editing === false || !item.editing) ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.propsEtapa !== 'Autorização'),
        expression: "propsEtapa !== 'Autorização'"
      }],
      staticClass: "fa fa-edit",
      staticStyle: {
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editItem(item, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.propsEtapa !== 'Autorização'),
        expression: "propsEtapa !== 'Autorização'"
      }],
      staticClass: "fa fa-check",
      staticStyle: {
        "color": "green",
        "margin-left": "5px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(item, 2)
        }
      }
    }) : _vm._e()])])
  }), 0), _vm._v(" "), _c('tfoot', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Valor total de recursos contratados: ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4",
      "bgcolor": "#F0F8FF"
    }
  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4",
      "bgcolor": "#F0F8FF"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.total)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Saldo restante do projeto:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.total)))]), _vm._v(" "), _c('td')])])])])]) : _vm._e(), _vm._v(" "), (_vm.totais.aglutinado === 'Não') ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12 financial-physical-schedule"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.itensProjeto), function(item) {
    return _c('tbody', [_c('tr', {
      staticStyle: {
        "background-color": "rgb(223, 228, 235)"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "9"
      }
    }, [_c('b', [_vm._v("Atividade:")]), _vm._v(" " + _vm._s(item.Atividade_nome) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao)), _c('br'), _vm._v("#" + _vm._s(item.Id_item) + " " + _vm._s(item.Item_Observacao))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(item.Item_Tipo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado)))]), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(item.quantidadeSolicitada))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantidadeSolicitada),
        expression: "item.quantidadeSolicitada"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "name": "quantidade a solicitar",
        "type": "text"
      },
      domProps: {
        "value": (item.quantidadeSolicitada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantidadeSolicitada", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item.editing === false || !item.editing) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(_vm._f("real")(item.valorSolicitado)))]) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_c('money', {
      staticClass: "form-control text-right",
      attrs: {
        "name": "valor a solicitar",
        "type": "text"
      },
      model: {
        value: (item.valorSolicitado),
        callback: function($$v) {
          _vm.$set(item, "valorSolicitado", $$v)
        },
        expression: "item.valorSolicitado"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(item.Qtde_orcado - item.quantidadeSolicitada - item.Qtde_liberado || 0))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(item.Qtde_saldo - (item.quantidadeSolicitada ? item.quantidadeSolicitada : 0)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa !== 'Solicitação') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_orcado - item.valorSolicitado - item.Valor_liberado)))]) : _vm._e(), _vm._v(" "), (_vm.propsEtapa === 'Solicitação') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo - (item.valorSolicitado ? item.valorSolicitado : 0))))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "border-right": "0.5px solid lavender"
      }
    }, [(item.editing === false || !item.editing) ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.propsEtapa !== 'Autorização'),
        expression: "propsEtapa !== 'Autorização'"
      }],
      staticClass: "fa fa-edit",
      staticStyle: {
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editItem(item, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.editing === true) ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.propsEtapa !== 'Autorização'),
        expression: "propsEtapa !== 'Autorização'"
      }],
      staticClass: "fa fa-check",
      staticStyle: {
        "color": "green",
        "margin-left": "5px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(item, 2)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), _c('tfoot', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Valor total de recursos contratados: ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4",
      "bgcolor": "#F0F8FF"
    }
  }, [_vm._v("Valor total da solicitação:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4",
      "bgcolor": "#F0F8FF"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.valorTotalSolicitacao)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Saldo restante do projeto:\t")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.valor_total_contratado - _vm.valorTotalSolicitacao)))]), _vm._v(" "), _c('td')])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 financial-physical-schedule"
  }, [_c('table', {
    staticClass: "table table-condensed table-striped table-bordered",
    staticStyle: {
      "min-width": "750px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.totalFBB > 0 || _vm.totalFaseFBB > 0) ? _c('tr', [_c('td', [_vm._v("Fundação")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFaseFBB)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantadoFaseFBB)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.saldoFaseFBB)))])]) : _vm._e(), _vm._v(" "), (_vm.totalPAR > 0 || _vm.totalFasePAR > 0) ? _c('tr', [_c('td', [_vm._v("Parceiro Estratégico")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalPAR)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFasePAR)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantadoFasePAR)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.saldoFasePAR)))])]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cronograma Físico-Financeiro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Valor a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "7%"
    }
  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Valor a comprovar")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total da fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total de adiantamento por fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total já adiantado")]), _vm._v(" "), _c('th', [_vm._v("Saldo de adiantamento restante por fase")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63d6efde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/cronograma-solicitacao-prestacaocontas.vue
// module id = 1984
// module chunks = 1